

























































































import { Component, Vue, Prop } from "vue-property-decorator";
import axios, { resHandle } from "@/plugins/axios";
import ObjectSelectSearch from "./object-select-search.vue";
@Component({
  components: {
    ObjectSelectSearch
  }
})
export default class EdrDetailContentZhusu extends Vue {
  @Prop()
  private content: any;
  private hashKey: any = new Date().getTime();
  /**
   * @description 获取store中的可编辑状态
   */
  private get ifCompose() {
    return this.$store.state.edrIfCompose;
  }
  /**
   * @description content双向绑定
   */
  private contentChange() {
    this.$emit("update:content", this.content);
  }
  /**
   * @description 删除一个
   */
  private deleteOne(index) {
    this.content.value.splice(index, 1);
    if (this.content.value.length === 0) {
      this.content.value = [{ setting: {}, value: {} }];
    }
    this.$forceUpdate();
  }
  /**
   * @description 添加一个
   */
  private addOne() {
    this.content.value.push({ setting: {}, value: {} });
    this.$forceUpdate();
  }
  private test(ev, value) {
    console.log(ev);
    value = ev;
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.hashKey = new Date().getTime();
  }
}
